const API_BASE = '/widgets';

export const API_ENDPOINTS = {
  widgets: {
    sessions: {
      init: `${API_BASE}/sessions/init`,
      open: `${API_BASE}/sessions/open`
    },
    ws: {
      token: `${API_BASE}/sessions/obtain_ws_auth_token`,
      subscriptionToken: `${API_BASE}/sessions/get_subscription_info`
    },
    messages: {
      add: `${API_BASE}/messages/add`,
      history: `${API_BASE}/messages/list`
    },
    attachments: {
      upload: `${API_BASE}/attachments/upload`
    },
    config: `${API_BASE}/config/get`,
    consents: {
      submit: `${API_BASE}/consents/submit`
    },
    contacts: {
      submit: `${API_BASE}/contacts/submit`
    }
  }
};
